import React from 'react'
import { RouteComponentProps } from '@reach/router'

export default function Loading(props: RouteComponentProps) {
    return (
        <div className="bg-white fixed top-0 right-0 h-screen w-screen z-50 flex justify-center items-center">
            <div className="animate-spin rounded-full h-32 w-32 border-t-2 border-b-2 border-red-300"></div>
        </div>
    )
}
